import React, { Component } from "react";

// Assets
import CreatorImage from "../../Assets/Thor.png";

// About Us Component
export default class AboutUs extends Component {
  aboutUsDescription(name) {
    return (
      <div className="Home_AUDescBlock">
        <div className="Home_CreatorImage">
          <img src={CreatorImage} alt="Creator Image" />
        </div>
        <div className="Home_CreatorName">Mr. {name}</div>
        <div className="Home_AULine"></div>
        <div className="Home_Work">Web Developer</div>
        <div className="Home_ClgDesc">
          I’m {name}
          <br />
          Student of Sarhad College Of Arts Commerce & Science
          <br />
          (Msc (Computer Science) Department)
        </div>
        <div className="Home_CreatorContributionBlock">
          <div className="Home_ContributionTitle">Contribution</div>
          <div className="Home_ContributionList">
            <div className="Contribution">UI/UX Designer</div>
            <div className="Contribution">FrontEnd Developer</div>
            <div className="Contribution">BackEnd Developer</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="Home_AboutUs">
        <div className="Home_AboutUsTitle">Know About Us</div>
        <div className="Home_AboutUsDesc">
          {this.aboutUsDescription("Aditya Sayaji Dhamal")}
          {this.aboutUsDescription("Prathamesh Revan Vibhute")}
        </div>
      </div>
    );
  }
}
